import React from 'react';
import { Modal, PrimaryButton } from '../../../components';

export const VerificationModal = ({
  isOpen,
  onClose,
  verificationLink,
  context = 'payout', // Default context is payout, can also be 'login'
}) => {
  // Different content based on the context
  const titles = {
    payout: 'Complete Your Verification',
    login: 'Verification Required',
  };

  const messages = {
    payout: 'To proceed with your payout claim, please verify your account.',
    login: 'Hey there! It looks like your account still needs to be verified.',
  };

  // For login context, we might want to allow skipping verification for now
  const showLaterButton = context === 'login';

  return (
    <Modal open={isOpen} onOpenChange={onClose} title={titles[context]}>
      <div style={{ textAlign: 'center' }}>
        <p>{messages[context]}</p>
        <br />
        <p>
          {' '}
          To keep transactions secure, Stripe requires all sellers on THE NOLD to upload an ID. It
          only takes a minute, and you'll be all set to receive your payouts.
        </p>
        <br />
        <p>
          For more details,{' '}
          <u>
            <a href="https://thenold.com/legal/terms-and-conditions">check our T&C here</a>.
          </u>
        </p>
        <br />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <PrimaryButton onClick={() => window.open(verificationLink)}>Verify Now</PrimaryButton>

          {showLaterButton && (
            <PrimaryButton onClick={onClose} variant="secondary">
              I'll do this later
            </PrimaryButton>
          )}
        </div>
      </div>
    </Modal>
  );
};

export const SuccessModal = ({ isOpen, onClose }) => (
  <Modal open={isOpen} onOpenChange={onClose} title="Verification Success">
    <div>
      <p>Congratulations! Your account has been successfully verified.</p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <PrimaryButton onClick={onClose}>Close</PrimaryButton>
      </div>
    </div>
  </Modal>
);

export const RetryModal = ({ isOpen, onClose, verificationLink }) => (
  <Modal open={isOpen} onOpenChange={onClose} title="Verification Failed">
    <div>
      <p>
        We encountered an issue verifying your account. Please try again to ensure a smooth payout
        process.
      </p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <PrimaryButton onClick={() => window.open(verificationLink)}>Verify Now</PrimaryButton>
      </div>
    </div>
  </Modal>
);
